import { render, staticRenderFns } from "./TaxPaymentDocument.vue?vue&type=template&id=d8195588&"
import script from "./TaxPaymentDocument.vue?vue&type=script&lang=ts&"
export * from "./TaxPaymentDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports